import { createActionGroup, props } from "@ngrx/store";
import { EcoLabel } from "src/api-service";
import { AppError } from "../../../../app-store-error.types";

export const DataEcoLabelsActions = createActionGroup({
    source: "Data / Eco Labels",
    events: {
        "Load": props<{ companyId: string }>(),
        "Load Success": props<{ ecoLabels: EcoLabel[] }>(),
        "Load Failure": props<{ error: AppError; toastKey: string }>(),
    },
});
